/* =================== MÁSCARAS DOS CAMPOS =================== */

// VALOR
$(".valor").mask("000.000.000.000.000,00", { reverse: true });

// CEP
$(".cep").mask("00000-000");

// DATA
$(".data").mask("00/00/0000");

// CPF
$(".cpf").mask("000.000.000-00", { reverse: true });

// CNPJ
$(".cnpj").mask("00.000.000/0000-00", { reverse: true });

// CPF OU CNPJ
var cpfCnpj = function (val) {
    return val.length > 14 ? "00.000.000/0000-00" : "000.000.000-009";
  },
  optionsDocumento = {
    onKeyPress: function (val, e, field, options) {
      field.mask(cpfCnpj(val), options);
    },
  };
$(".cpf-cnpj").mask(cpfCnpj, optionsDocumento);

// TELEFONE
var telefoneSP = function (val) {
    return val.replace(/\D/g, "").length === 11
      ? "(00) 00000-0000"
      : "(00) 0000-00009";
  },
  spOptions = {
    onKeyPress: function (val, e, field, options) {
      field.mask(telefoneSP.apply({}, arguments), options);
    },
  };
$(".telefone").mask(telefoneSP, spOptions);

// CARTÃO DE CRÉDITO
$(".card-numero").mask("0000 0000 0000 0000", { reverse: true });

// CARTÃO DE CRÉDITO (VALIDADE)
$(".card-validade").mask("00/00");

// Tradução para o pluging 'Datepicker'
const datepickerLocaleBR = {
  format: "DD/MM/YYYY",
  separator: " a ",
  applyLabel: "Aplicar",
  cancelLabel: "Limpar",
  fromLabel: "De",
  toLabel: "a",
  customRangeLabel: "Personalizado",
  daysOfWeek: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
  monthNames: [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ],
};

// ------------------------------------
// Datepicker
// ------------------------------------
(function () {
  "use strict";

  // Datepicker
  $(".datepicker").each(function () {
    const openDirection =
      $(this).data("direction") && $(this).data("direction") === "right"
        ? "left"
        : "right";
    $(this)
      .daterangepicker({
        singleDatePicker: true,
        autoUpdateInput: false,
        autoApply: true,
        opens: openDirection,
        locale: datepickerLocaleBR,
      })
      .on("apply.daterangepicker", function (ev, picker) {
        $(this).val(picker.startDate.format("DD/MM/YYYY"));
        //$(this).parsley().validate();
      })
      .on("cancel.daterangepicker", function (ev, picker) {
        $(this).val("");
      });
  });

  // Datepicker Range
  $(".datepicker_range").each(function () {
    const $campo = $(this);
    const openDirection =
      $campo.data("direction") && $campo.data("direction") === "right"
        ? "left"
        : "right";
    $campo
      .daterangepicker({
        autoUpdateInput: false,
        autoApply: false,
        opens: openDirection,
        locale: datepickerLocaleBR,
        buttonClasses: "btn btn-xs",
        applyButtonClasses: "btn-primario",
      })
      .on("apply.daterangepicker", function (ev, picker) {
        $(this).val(
          picker.startDate.format("DD/MM/YYYY") +
            " a " +
            picker.endDate.format("DD/MM/YYYY")
        );
        $(this).parsley().validate();
      })
      .on("cancel.daterangepicker", function (ev, picker) {
        $campo.val("");
        $(this).parsley().validate();
      });
  });

  // Datepicker Range Pré-definidos
  $(".datepicker_prerange").each(function () {
    const $campo = $(this);
    const openDirection =
      $campo.data("direction") && $campo.data("direction") === "right"
        ? "left"
        : "right";
    $campo
      .daterangepicker({
        autoUpdateInput: false,
        autoApply: false,
        opens: openDirection,
        locale: datepickerLocaleBR,
        //alwaysShowCalendars: true,
        buttonClasses: "btn btn-xs",
        applyButtonClasses: "btn-primario",
        ranges: {
          Hoje: [moment(), moment()],
          Ontem: [moment().subtract(1, "days"), moment().subtract(1, "days")],
          "Últimos 7 dias": [moment().subtract(6, "days"), moment()],
          "Últimos 30 dias": [moment().subtract(29, "days"), moment()],
          "Este mês": [moment().startOf("month"), moment().endOf("month")],
          "Último mês": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        },
      })
      .on("apply.daterangepicker", function (ev, picker) {
        $(this).val(
          picker.startDate.format("DD/MM/YYYY") +
            " a " +
            picker.endDate.format("DD/MM/YYYY")
        );
        $(this).parsley().validate();
      })
      .on("cancel.daterangepicker", function (ev, picker) {
        $campo.val("");
        $(this).parsley().validate();
      });
  });

  // Time Picker
  $(".timepicker").each(function () {
    const openDirection =
      $(this).data("direction") && $(this).data("direction") === "right"
        ? "left"
        : "right";
    const timepickerLocaleBR = datepickerLocaleBR;
    timepickerLocaleBR.format = "HH:mm";
    $(this)
      .daterangepicker({
        singleDatePicker: true,
        timePicker: true,
        timePicker24Hour: true,
        autoUpdateInput: false,
        opens: openDirection,
        locale: datepickerLocaleBR,
        buttonClasses: "btn btn-xs",
        applyButtonClasses: "btn-primario",
      })
      .on("show.daterangepicker", function (ev, picker) {
        picker.container.addClass("timepicker");
      })
      .on("apply.daterangepicker", function (ev, picker) {
        $(this).val(picker.startDate.format(timepickerLocaleBR.format));
        //$(this).parsley().validate();
      })
      .on("cancel.daterangepicker", function (ev, picker) {
        $(this).val("");
      });
  });
})();
